import types from "./types";

export const setSpreedlyToken = (token) => {
  return {
    type: types.SET_TOKEN,
    token,
  };
};

export const setSpreedlyValid = (validity) => {
  return {
    type: types.SET_VALIDITY,
    validity,
  };
};

export const setSpreedlyErrors = (errors) => {
  return {
    type: types.SET_VALIDATION_ERRORS,
    errors,
  };
};

export const triggerSpreedlyValidation = (bool) => {
  return {
    type: types.SET_TRIGGER_VALIDATION,
    bool,
  };
};
